// extracted by mini-css-extract-plugin
export default {"root":"PasswordResetForm_root__an9ih","password":"PasswordResetForm_password__SZs3b marketplaceModalPasswordMargins","submitButton":"PasswordResetForm_submitButton__wyr7e"};